export enum variantOptions {
  outline = "outline",
  gray = "gray",
  unstyled = "unstyled",
}
